<template>
  <Layout>
    <FilterPanel :modelValue="filter" @update:modelValue="setFilter" />
    <div class="layout--horizontal layout--alignment-flex-start">
      <ServiceGeneralIndicator :filter="filter" />
      <ServiceStagePassPercent :filter="filter" />
    </div>
    <ServiceDeliveryProccess :filter="filter" />
  </Layout>
</template>

<script>
import useServicesFilter from "@/components/services/filter";
import Layout from "./Layout";
import ServiceGeneralIndicator from "@/components/services/ServiceGeneralIndicator";
import ServiceStagePassPercent from "@/components/services/ServiceStagePassPercent";
import ServiceDeliveryProccess from "@/components/services/ServiceDeliveryProccess";
import FilterPanel from "@/components/services/FilterPanel";

export default {
  components: {
    Layout,
    FilterPanel,
    ServiceGeneralIndicator,
    ServiceStagePassPercent,
    ServiceDeliveryProccess,
  },
  setup() {
    const { filter, setFilter } = useServicesFilter();

    return {
      filter,
      setFilter,
    };
  },
};
</script>
